// extracted by mini-css-extract-plugin
module.exports = {"loaderStyles":"Loader_loaderStyles__1wEh5"};